import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { fmtMoney } from "../../functions";

import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';




const CustomTooltip = ({ active, payload, label, indicador }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label" style={{ color: '#000'}}>{`${label} : ${ indicador == 'custo' ? payload[0].value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : fmtMoney(payload[0].value, 0).toString().replace('R$', '') }`}</p>
          
        </div>
      );
    }
  
    return null;
  };


const Modal = (props) => {

    const energia_id = props.energia_id

    const [dataGrafico, setDataGrafico] = useState([])

    const [totalRegistros, setTotalRegistros] = useState(0)

    const [totalConsumoAno, setTotalConsumoAno] = useState(0)
    const [totalCustoAno, setTotalCustoAno] = useState(0)
    const [totalCustoMedio, setTotalCustoMedio] = useState(0)

    const [indicador, setIndicador] = useState('consumo')
    const [posto, setPosto] = useState('')
    const [fatura, setFatura] = useState('')

    const [resultadoFatura, setResultadoFatura] = useState()

    const [custoTotal, setCustoTotal] = useState(0)
    const [totalConsumo, setTotalConsumo] = useState(0)
    const [custoMedio, setCustoMedio] = useState(0)
    const [nomeGrafico, setNomeGrafico] = useState('')


    function carregaFatura() {


        api.get(`energiaEletricaCompradaListaTodos/${energia_id}`).then((result) => {

            setTotalRegistros(result.data.length)

            setResultadoFatura(result.data.map((rs) =>

                <option value={rs.energiaEletricaComprada_id}>{rs.descricaoFatura}</option>

            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }




    function carregaResumo() {


        if (energia_id) {


            api.get(`energiaEletricaResumoConsumo/${energia_id}`).then((result) => {

                //console.log(result.data, '!!')

                var data = result.data

                setCustoTotal(data.custoTotal)
                setTotalConsumo(data.totalConsumo)
                setCustoMedio(data.custoMedio)

                /*
                setDataGrafico(result.data.map((rs) => {
           
                    return {
    
                        name: rs.name,
                        custo: rs.custo,
                            
                    }
    
                                   
    
                }))
                */

            }).catch((err) => {

                console.log(err.response)

            })


        }


    }

    function graficoResumo() {

        //console.log(indicador, 'aqui')

        switch (indicador) {

            case 'consumo':

                if (posto && fatura) {

                    setNomeGrafico('Consumo [kWh]')

                    //console.log(`energiaEletricaGraficoConsumo/${energia_id}/${fatura}/${posto}`)
                    api.get(`energiaEletricaGraficoConsumo/${energia_id}/${fatura}/${posto}`).then((result) => {

                        

                        setDataGrafico(result.data.map((rs) => {

                            return {
        
                                name: rs.name,
                                uv: parseInt(rs.consumo),
                                //meta: rs.meta,
                            }
        

                        }))

                    }).catch((err) => {

                        console.log(err.response)

                    })

                
                
        

                break
            }

            case 'demanda':

                if (posto && fatura) {

                    

                    setNomeGrafico('Demanda [kW]')

                    //console.log(`energiaEletricaGraficoDemanda/${energia_id}/${fatura}/${posto}`)
                    
                    api.get(`energiaEletricaGraficoDemanda/${energia_id}/${fatura}/${posto}`).then((result) => {
                        
                        //console.log(result.data, '!!')

                        setDataGrafico(result.data.map((rs) => {
        
                            return {
            
                                name: rs.name,
                                uv: parseInt(rs.demanda),
                                    
                            }
            
                                        
            
                        }))


                    }).catch((err) => {

                        console.log(err.response)

                    })

                }

                break

            case 'custo':

                setPosto('')

                if (fatura) {

                    setNomeGrafico('Custo [R$]')

                    console.log(`energiaEletricaGraficoCusto/${energia_id}/${fatura}`)
                    api.get(`energiaEletricaGraficoCusto/${energia_id}/${fatura}`).then((result) => {

                        console.log(result.data)    

                        setDataGrafico(result.data.map((rs) => {
        
                            return {
            
                                name: rs.name,
                                uv: rs.custo,
                                    
                            }
            
                                        
            
                        }))


                    }).catch((err) => {

                        console.log(err.response)

                    })

                }

                break

                

        }
    }



    const graficoResumoTotais = () => {

        //console.log('!!!')

        api.get(`graficoResumoTotais/${energia_id}`).then((result) => {

            //console.log(result.data)
            var data = result.data[0]

            

            setTotalConsumoAno(fmtMoney(data.totalConsumoAno).toString().replaceAll('R$', ''))
            setTotalCustoAno(fmtMoney(data.totalCustoAno).toString().replaceAll('R$', ''))
            setTotalCustoMedio(data.totalCustoMedio)



        }).catch((err) => {

            console.log(err.response)

        })


    }



    useEffect(() => {

        //console.log(dataPoints)
        setDataGrafico([])
        graficoResumo()

        //chart.render();

    }, [indicador, posto, fatura])



    useEffect(() => {

        carregaFatura()
        //carregaResumo()
        graficoResumoTotais()

    }, [energia_id])



    return (

        <div>

            <div className="modal fade" id="modalEnergiaEletricaResumo" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Energia Elétrica - Resumo</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">

                                <div class="col-md-12">

                                    <div className="table-responsive">

                                        
                                        <table width="100%">
                                            <tr>
                                                <td style={{ backgroundColor: '#e5cfe8'}}>
                                                    Resumo para Consumo de Energia Elétrica Comprada
                                                </td>
                                            
                                            </tr>
                                            <tr>
                                                <td>
                                                    Consumo Total Anual: <b>{totalConsumoAno} kWh</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Custo Total Anual: R$ <b>{totalCustoAno}</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Custo Médio: <b>{totalCustoMedio} R$/kWh</b>
                                                </td>
                                            </tr>
                                            
                                        </table>


                                        <div className="row">
                                            
                                            
                                            <div className="col-md-4">
                                                <div class="form-group" >
                                                    <br/><br/>
                                                    <label className="control-label">Fatura</label>
                                                    <select className="form-control" value={fatura} onChange={event => setFatura(event.target.value)}>
                                                            <option value="">[Selecione]</option>
                                                            {resultadoFatura}
                                                    </select>
                                                        
                                                        
                                                </div>
                                            </div>
                                            <div className="col-md-4" >
                                                <div class="form-group" >
                                                    <br/><br/>
                                                    <label className="control-label">Indicador</label>
                                                    <select className="form-control" value={indicador} onChange={event => setIndicador(event.target.value)}>
                                                            <option value="consumo">Consumo [kWh]</option>
                                                            <option value="demanda">Demanda [kW]</option>
                                                            <option value="custo">Custo [R$]</option>
                                                    </select>
                                                        
                                                        
                                                </div>
                                            </div>
                                            <div className="col-md-4" >
                                                <div class="form-group" >
                                                    <br/><br/>
                                                    <label className="control-label">Posto</label>
                                                    <select className="form-control" value={posto} onChange={event => setPosto(event.target.value)} disabled={ indicador == 'custo' ? true : false}>
                                                            <option value="">[Selecione]</option>
                                                            <option value="ponta">Ponta/Único</option>
                                                            <option value="fora">Fora</option>
                                                    </select>
                                                        
                                                        
                                                </div>
                                            </div>
                                            

                                        </div>


                                        <br/>


                                        <ResponsiveContainer width="100%" height={200}>

                                                                                
                                        <LineChart width={730} height={250} data={dataGrafico}
                                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                            <XAxis dataKey="name" style={{ fontSize: '11px', fontFamily: 'Arial' }} />
                                            <YAxis tickFormatter={(value) =>
                                                new Intl.NumberFormat("pt-BR", {
                                                notation: "compact",
                                                compactDisplay: "short",
                                                }).format(value)}
                                                style={{ fontSize: '10px', fontFamily: 'Arial' }}  />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip content={<CustomTooltip indicador={indicador} />} cursor={{ fill: "transparent" }} />
                                            
                                            <Line name="" type="monotone" dataKey="pv" stroke="#8884d8" />
                                            <Line name="" type="monotone" dataKey="uv" stroke="#82ca9d" />
                                        </LineChart>


                                        </ResponsiveContainer>

                                    </div>

                                </div>



                            </div>
                                    

                            </div>
                            <div className="modal-footer">

                                
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal